import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAuthContext } from '@/modules/auth/ui/AuthProvider';
import { ErrorProvider } from '@/modules/admin/context/ErrorContext';

export default function AdminErrorsWrapper() {
  const { authFetch } = useAuthContext();
  
  return (
    <ErrorProvider authFetch={authFetch}>
      <Outlet />
    </ErrorProvider>
  );
}
